$(document).ready(function () {
    $('.cke-new p').each(function () {
        if ($.trim($(this).text()) == '' && $(this).children().length == 0) {
            $(this).hide();
        }
    });
});
